import { AddCountryComponent } from './add-country/add-country.component';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/core/services/data.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { reduce, Subject } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';


@Component({
    selector: 'app-country-affiliation',
    templateUrl: './country-affiliation.component.html',
    styleUrls: ['./country-affiliation.component.css'],
    standalone: false
})
export class CountryAffiliationComponent {
  citizen: any[] = [];
  selectedCountry: any;
  // countryCodeMap: { [key: string]: string } = {
  //   "United Arab Emirates": "ae",
  //   "India": "in",
  //   "United States": "us",
  //   "USA": "us",
  //   "Canada": "ca",
  //   // Add more as needed
  // };

  countryCodeMap: { [key: string]: string } = {
    "Argentina": "ar",
    "Australia": "au",
    "Austria": "at",
    "Belgium": "be",
    "Bosnia": "ba",
    "Brazil": "br",
    "Bulgaria": "bg",
    "Canada": "ca",
    "Chile": "cl",
    "China": "cn",
    "Croatia": "hr",
    "Czech Republic": "cz",
    "Denmark": "dk",
    "Estonia": "ee",
    "Finland": "fi",
    "France": "fr",
    "Germany": "de",
    "Herzegovina": "ba", // Bosnia and Herzegovina use the same code
    "Iceland": "is",
    "India": "in",
    "Indonesia": "id",
    "Israel": "il",
    "Italy": "it",
    "Latvia": "lv",
    "Lithuania": "lt",
    "Macedonia": "mk",
    "Malaysia": "my",
    "Mexico": "mx",
    "Moldova": "md",
    "Montenegro": "me",
    "Netherlands": "nl",
    "New Zealand": "nz",
    "Norway": "no",
    "Poland": "pl",
    "Portugal": "pt",
    "Romania": "ro",
    "Serbia": "rs",
    "Singapore": "sg",
    "Slovakia": "sk",
    "Slovenia": "si",
    "South Africa": "za",
    "South Korea": "kr",
    "Spain": "es",
    "Sweden": "se",
    "Switzerland": "ch",
    "Turkey": "tr",
    "Ukraine": "ua",
    "United Arab Emirates": "ae",
    "United Kingdom": "gb",
    "United States": "us",
    "USA": "us"
  };
  country: any;
  showConfirmDialog = false;
  countryToDelete: any = null;
  affiliations:any[] = [];


  constructor(private dialog: MatDialog, private sanitizer: DomSanitizer, private fb: FormBuilder,
    private auth: AuthService, private data: DataService, private router: Router, private toast: ToastrService,) { }

  ngOnInit() {
    this.getCitizenships();
    this.getCountries();
  }

  // getCitizenships() {
  //   this.auth.get_citizenship().subscribe((res: any) => {
  //     this.citizen = res.data?.citizenships || [];
  //     if (this.citizen.length > 0) {
  //       this.selectedCountry = this.citizen[0]; // Now selects the last entry first
  //     }
  //   });
  // }

  getLog() {
    console.log('Log')
    console.log('aff selectedCountry', this.selectedCountry)
    this.auth.get_aff_type_con(this.selectedCountry?.country).subscribe((res: any) => {
      this.affiliations = res.data?.affiliations || [];
      // console.log('--Affiliation Types:', res.data);
    });

  }

  getCitizenships() {
    console.log('selectedCountry',this.selectedCountry)
    this.auth.get_citizenship().subscribe((res: any) => {
      const order = [
        'citizen_primary',
        'citizen_second',
        'citizen_third',
        'citizen_fourth'
      ];

      this.citizen = (res.data?.citizenships || []).sort((a: any, b: any) => {
        return order.indexOf(a.index) - order.indexOf(b.index);
      });
      // console.log('Citizenships:', this.citizen);
      if (this.citizen.length > 0) {
        this.selectedCountry = this.citizen[0]; // Default to primary
      }
    });

    this.auth.get_aff_type_con(this.selectedCountry).subscribe((res: any) => {
      this.affiliations = res.data?.affiliations || [];
      // console.log('--Affiliation Types:', res.data);
    });

  }

  // mapAffiliationType(type: any) {
  //   // Normalize: Treat 'citz' and 'pr' as same
  //   if (type === 'citz') type = 'pr';

  //   const match = this.affiliations.find((a: any) => a.aflType === type);
  //   return match ? match.aflName : 'Unknown';
  // }
  mapAffiliationType(type: any) {
    if (!type) return 'Not provided';

    // Handle custom mappings
    const customMap: Record<string, string> = {
      citz: 'Citizenship',
      pr: 'Permanent Resident',
      tvs: 'Temporary Resident - Student',
      dcitz: 'Dual Citizenship',
      tvw: 'Temporary Resident - Work'
    };

    if (customMap[type]) {
      return customMap[type];
    }
    
    const match = this.affiliations.find((a: any) => a.aflType === type); // affiliations list
    return match ? match.aflName : 'Unknown';
  }


  getCountries() {
    this.auth.getCountries().subscribe((res: any) => {
      this.country = res.data.country;
    });
  }

  selectCountry(item: any) {
    this.selectedCountry = item;
  }

  // openAddCountryDialog() {
  //   this.dialog.open(AddCountryComponent, {
  //     width: '500px',
  //     height: '500px',
  //     panelClass: 'custom-dialog-container',
  //     disableClose: true
  //   });
  // }
  openAddCountryDialog(data?: any) {
    const dialogRef = this.dialog.open(AddCountryComponent, {
      width: '500px',
      height: '500px',
      panelClass: 'custom-dialog-container',
      disableClose: true,
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log('Dialog result:', result);
      this.getCitizenships();
      this.getCountries();
    });
  }

  getCountryCode(countryName: string): string {
    const name = countryName.trim();
    return this.countryCodeMap[name] || '';
  }

  getFlagUrl(countryName: string): string {
    const code = this.getCountryCode(countryName).toLowerCase();
    return code ? `https://flagcdn.com/${code}.svg` : '';
  }

  getCountryRole(index: string): string {
    switch (index) {
      case 'citizen_primary':
        return 'Primary Country';
      case 'citizen_second':
        return 'Secondary Country';
      case 'citizen_third':
        return 'Third Country';
      case 'citizen_fourth':
        return 'Fourth Country';
      default:
        return 'Other';
    }
  }

  confirmDeleteCountry(country: any) {
    this.countryToDelete = country;
    this.showConfirmDialog = true;
  }

  handleConfirmDelete() {
    if (!this.countryToDelete) return;

    this.auth.delete_country(this.countryToDelete.index).subscribe({
      next: (res: any) => {
        if (!res.error) {
          this.toast.success(res.msg || 'Country removed');
          this.getCitizenships();
          this.selectedCountry = this.citizen[0] || null;
        } else {
          this.toast.error(res.msg || 'Failed to delete');
        }
        this.resetDeleteDialog();
      },
      error: (err) => {
        this.toast.error(err.error.msg || 'Error while deleting country');
        this.resetDeleteDialog();
      }
    });
  }

  resetDeleteDialog() {
    this.showConfirmDialog = false;
    this.countryToDelete = null;
  }

  shouldHideAddButton(): boolean {
    //console.log('Citizen entries:', this.citizen);
    const hasFourth = this.citizen.some(c => c.index === 'citizen_fourth');
    return this.citizen.length >= 4;
  }

  shouldDisableRemove(item: any): boolean {
    return item?.index === 'citizen_primary';
  }

}
